<template>
    <p class="control">
      <multiselect @input="emitAbsence()"
        v-model="absenceCode" 
        :options="absenceInput"
        :placeholder="$t('input.choose')"
        track-by="code"
        label="description"
        :select-label="$t('input.choose')"
        :deselect-label="$t('input.remove')">
        <span slot="noResult">{{$t("input.notFound")}}</span>
      </multiselect>
    </p>
</template>

<script>
import firebase from '@/firebase'
import moment from 'moment'
import _ from 'lodash'
import Multiselect from 'vue-multiselect'

export default {
  name: 'AbsenceSelect',
  components: {
      Multiselect
    },
  props: {
      absenceCodes: Array,
      customAbsence: Object,
      useCustomAbsence: Boolean,
  },
  data: function() {
      return {
        absenceCode: false
      }
  },
  computed: {
    absenceInput() {
      if(!this.useCustomAbsence) {
        return this.absenceCodes;
      } else {
        return this.customAbsenceCodes;
      }
    },
    customAbsenceCodes() {
      return _.map(this.customAbsence, function(absence, key) {
        return {
          code: absence.name,
          description: absence.name,
          measure: 'DAGE'
        }
      })
    }
  },
  methods: {
    emitAbsence: function() {
      try {
        this.$emit('absence', this.absenceCode);
      } catch(err) {
        console.log("Error: ", err.message);
      }
    }
  },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
